// The chrome around every widget on the canvas: a draggable title bar + a
// remove button, with the widget's own component rendered in the body. The
// title bar is the drag handle (`.canvas-drag`); the remove button is excluded
// from dragging (`.canvas-no-drag`) so clicking ✕ removes instead of dragging.

import type { ReactNode } from "react";
import { theme } from "../lib/theme.js";

export default function WidgetFrame({
  title,
  onRemove,
  children,
}: {
  title: string;
  onRemove: () => void;
  children: ReactNode;
}) {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: theme.tile,
        border: `1px solid ${theme.border}`,
        borderRadius: 12,
        overflow: "hidden",
      }}
    >
      <div
        className="canvas-drag"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: theme.tileHeader,
          padding: "9px 12px",
          borderBottom: `1px solid ${theme.border}`,
          cursor: "move",
          flexShrink: 0,
        }}
      >
        <span style={{ color: theme.ink, fontSize: 14, fontWeight: 500 }}>{title}</span>
        <button
          className="canvas-no-drag"
          aria-label={`Remove ${title}`}
          onClick={onRemove}
          style={{
            border: "none",
            background: "transparent",
            color: theme.inkMuted,
            fontSize: 16,
            lineHeight: 1,
            cursor: "pointer",
            padding: "0 2px",
          }}
        >
          ×
        </button>
      </div>
      {/* Body scrolls if the widget is taller than its tile. */}
      <div style={{ flex: 1, overflow: "auto", padding: 12 }}>{children}</div>
    </div>
  );
}
